import styles from "./header.module.css";

function Header({ companyName = "Company", logo = "/images/logo2.svg" }) {
  return (<div className={`${styles.Header}`}>
    <div className={`${styles.Container}`}>
      <div className={`${styles.HeadRow}`}>
        <img src={logo} alt={companyName} className={`${styles.HeadLogo}`} />
      </div>
    </div>
  </div>);
}

export default Header;